import React from 'react'

export const IcoLogOut = ({...props}) => {
  const style = props.style?props.style:{}
  return (
    <svg className='icon-log-out' viewBox="0 0 19 21" {...props} style={{...style,fill:'none'}}>
      <path d="M12 7.5V3.75C12 2.50736 10.9926 1.5 9.75 1.5L3.75 1.5C2.50736 1.5 1.5 2.50736 1.5 3.75L1.5 17.25C1.5 18.4926 2.50736 19.5 3.75 19.5H9.75C10.9926 19.5 12 18.4926 12 17.25V13.5M15 13.5L18 10.5M18 10.5L15 7.5M18 10.5L5.25 10.5" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  )
}